import React from 'react';
import { useTranslation } from 'react-i18next';

export default function BalancePill({ balance, onTopUp }) {
    const { t } = useTranslation();
    return (
        <div className="flex items-center gap-1.5 px-2 sm:px-3 py-1 rounded-md border border-cyber-purple/40 bg-cyber-purple/5">
            <div className="flex flex-col leading-tight">
                <span className="text-[9px] font-display tracking-widest text-cyber-dim">{t('game.credits')}</span>
                <span className="text-cyber-purple glow-purple font-display text-sm sm:text-lg font-bold leading-none">
                    {balance}<span className="text-cyber-dim text-[10px] sm:text-xs ml-1">¢</span>
                </span>
            </div>
            {onTopUp && (
                <button
                    onClick={onTopUp}
                    title={t('profile.topUp')}
                    className="ml-0.5 inline-flex items-center justify-center w-6 h-6 rounded-full border border-cyber-cyan/60 text-cyber-cyan hover:bg-cyber-cyan/15 hover:shadow-neon transition text-sm font-bold leading-none"
                    aria-label={t('profile.topUp')}
                >
                    +
                </button>
            )}
        </div>
    );
}
